interface Props {
    className?: string
    FillColor?: string
}

export default function LightBulb({className, FillColor = 'black'}:Props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24"  className={className}>
            <path
                d="M11.55 1.5C11.3843 1.5 11.25 1.63431 11.25 1.8V3.3C11.25 3.96274 11.7873 4.5 12.45 4.5C12.6157 4.5 12.75 4.36569 12.75 4.2V2.7C12.75 2.03726 12.2127 1.5 11.55 1.5Z"
                fill={FillColor} />
            <path
                d="M16.4636 16.0096C15.6806 16.8807 15 17.9186 15 19.0899C15 19.3164 14.8164 19.5 14.5899 19.5H9.41015C9.18363 19.5 9 19.3164 9 19.0899C9 17.9186 8.31941 16.8807 7.53642 16.0096C6.58121 14.947 6 13.5414 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 13.5414 17.4188 14.947 16.4636 16.0096ZM15.348 15.0069C16.0654 14.2088 16.5 13.157 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 13.157 7.93465 14.2088 8.65197 15.0069C9.31201 15.7411 10.0707 16.7555 10.3694 18H13.6306C13.9293 16.7555 14.688 15.7411 15.348 15.0069Z"
                fill={FillColor} />
            <path
                d="M10.2 21C9.53726 21 9 21.5373 9 22.2C9 22.3657 9.13431 22.5 9.3 22.5H13.8C14.4627 22.5 15 21.9627 15 21.3C15 21.1343 14.8657 21 14.7 21H10.2Z"
                fill={FillColor} />
            <path
                d="M17.5683 7.06816C17.0996 6.59953 17.0996 5.83974 17.5683 5.37111L18.7576 4.18177C18.8748 4.06461 19.0647 4.06461 19.1819 4.18177C19.6505 4.6504 19.6505 5.41019 19.1819 5.87882L17.9925 7.06816C17.8754 7.18532 17.6854 7.18532 17.5683 7.06816Z"
                fill={FillColor} />
            <path
                d="M21.3 12.75C21.9627 12.75 22.5 12.2127 22.5 11.55C22.5 11.3843 22.3657 11.25 22.2 11.25H20.7C20.0373 11.25 19.5 11.7873 19.5 12.45C19.5 12.6157 19.6343 12.75 19.8 12.75H21.3Z"
                fill={FillColor} />
            <path
                d="M6.43175 7.06823C6.90037 6.5996 6.90037 5.83981 6.43174 5.37118L5.24241 4.18184C5.12525 4.06468 4.9353 4.06468 4.81814 4.18184C4.34951 4.65047 4.34951 5.41026 4.81814 5.87889L6.00748 7.06823C6.12464 7.18539 6.31459 7.18539 6.43175 7.06823Z"
                fill={FillColor} />
            <path
                d="M3.3 12.75C3.96274 12.75 4.5 12.2127 4.5 11.55C4.5 11.3843 4.36569 11.25 4.2 11.25H2.7C2.03726 11.25 1.5 11.7873 1.5 12.45C1.5 12.6157 1.63431 12.75 1.8 12.75H3.3Z"
                fill={FillColor} />
        </svg>
    )
}
